import { render, staticRenderFns } from "./noticeConfigNew.vue?vue&type=template&id=e9709b72&scoped=true&"
import script from "./noticeConfigNew.vue?vue&type=script&lang=js&"
export * from "./noticeConfigNew.vue?vue&type=script&lang=js&"
import style0 from "./noticeConfigNew.vue?vue&type=style&index=0&id=e9709b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9709b72",
  null
  
)

export default component.exports